export default class StorefrontClient {

    constructor(game, network) {
        this.game = game
        this.network = network

        this.events = new Phaser.Events.EventEmitter()

        this.stores = new Map()
        this.pending = new Set()
        this.overlayVisible = false
    }

    getStore(storeId) {
        return this.stores.get(storeId) || null
    }

    handleLoadPlayer() {
        this.reset()
    }

    requestStore(storeId) {
        const key = typeof storeId === 'string' ? storeId.toLowerCase() : null
        if (!key) {
            return
        }

        if (!this.pending.has(key)) {
            this.pending.add(key)
            this.network.send('get_storefront', { storeId: key })
        }
    }

    upsertStore(payload) {
        if (!payload || typeof payload.storeId !== 'string') {
            return
        }

        const key = payload.storeId.toLowerCase()
        this.pending.delete(key)
        this.stores.set(key, payload)
        this.events.emit(`storefront:${key}`, payload)
        this.events.emit('storefront:update', payload)
    }

    emitError(payload) {
        if (!payload || typeof payload.storeId !== 'string') {
            return
        }

        const key = payload.storeId.toLowerCase()
        this.pending.delete(key)
        this.events.emit(`storefront-error:${key}`, payload)
        this.events.emit('storefront:error', payload)
    }

    setOverlayVisible(isVisible) {
        this.overlayVisible = Boolean(isVisible)
    }

    isOverlayVisible() {
        return this.overlayVisible
    }

    subscribe(storeId, callback, context) {
        if (typeof callback !== 'function') {
            return () => {}
        }

        const key = storeId.toLowerCase()
        this.events.on(`storefront:${key}`, callback, context)

        return () => this.events.off(`storefront:${key}`, callback, context)
    }

    subscribeToErrors(storeId, callback, context) {
        if (typeof callback !== 'function') {
            return () => {}
        }

        const key = storeId.toLowerCase()
        this.events.on(`storefront-error:${key}`, callback, context)

        return () => this.events.off(`storefront-error:${key}`, callback, context)
    }

    destroy() {
        this.events.removeAllListeners()
        this.reset()
    }

    reset() {
        this.stores.clear()
        this.pending.clear()
        this.overlayVisible = false
    }

}
